import React from 'react';
import SignInApp from 'apps/sign_in/sign_in_app';
import PreLoginAppLoader from 'utils/pre_login_app_loader';

PreLoginAppLoader(<SignInApp />);
